module.exports = __webpack_public_path__ + "static/media/layer.b0acb5f2.svg";